module.exports = __webpack_public_path__ + "img/manage-product-2.b48e695c.jpg";